import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';

/**
 * Props for `HeroWithTrustLogos`.
 */
export type HeroWithTrustLogosProps =
  SliceComponentProps<Content.HeroWithTrustLogosSlice>;

/**
 * Component for "HeroWithTrustLogos" Slices.
 */
const HeroWithTrustLogos = ({
  slice,
}: HeroWithTrustLogosProps): JSX.Element => {
  const {
    primary: { kicker, title, logos, background_image: bgImage },
  } = slice;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        backgroundImage: `url(${bgImage.url})`,
      }}
      className="bg-center bg-no-repeat bg-cover w-full h-full py-16 mt-[-5.375rem] pt-[8.9rem]"
    >
      <div className="container mx-auto px-4 md:px-6 text-white h-full w-full flex flex-col text-center justify-center items-center">
        <div className="flex flex-col items-center gap-y-7 w-full max-w-5xl">
          <div
            style={{
              fontWeight: '700',
              fontSize: '20px',
            }}
          >
            <PrismicRichText field={kicker} />
          </div>
          <div
            className="font-bold text-4xl md:text-5xl lg:text-6xl leading-tight"
            style={{
              fontWeight: '700',
              lineHeight: '120%',
            }}
          >
            <PrismicRichText field={title} />
          </div>
          <div className="flex flex-row flex-nowrap overflow-x-auto no-scrollbar items-center gap-x-7 pb-8">
            {logos.map((item, index) => (
              <div key={`company-logo-${index}`}>
                <PrismicNextImage field={item.logo} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroWithTrustLogos;
